import React from 'react';
import { SvgCircleIcon, IconComponent, IconGlyphComponent } from '@shapeable/icons';

export const FixingFashionIcon: IconComponent = (props) => (
  <SvgCircleIcon { ...props } glyphWidth={96} glyphHeight={96}>

  </SvgCircleIcon>
);

export const FixingFashionIconGlyph: IconGlyphComponent = (props) => <FixingFashionIcon { ...props } variant='glyph' />;